import { render, staticRenderFns } from "./DocumentsDownloadedDialog.vue?vue&type=template&id=6b2853cc"
import script from "./DocumentsDownloadedDialog.vue?vue&type=script&lang=js"
export * from "./DocumentsDownloadedDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDownloadedDialog.vue?vue&type=style&index=0&id=6b2853cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports